import { useRecoilState } from 'recoil';
import CompactToggle from '~/components/toolbar/shared/CompactToggle';
import { transformAllSupportState } from '~/state/atoms/toolsAtoms';

export default function TransformToolOptions() {
    const [moveAll, setMoveAll] = useRecoilState(transformAllSupportState);

    return (
        <CompactToggle
            labelId="toolbar.transform.moveAllSupport"
            tooltipId="toolbar.transform.moveAllSupport.tooltip"
            value={moveAll}
            onChange={setMoveAll}
        />
    );
}
